<template>
  <div>
    <apexchart width="100%" height="170px" type="bar" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: ["recebidas", "visualizadas", "compraram"],
  data: _ => {
    return {
      options: {
        chart: {
          id: "visualizacoes-compras"
        },
        xaxis: {
          categories: ["Recebidas", "Visualizadas", "Compraram"]
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true
          }
        },
        dataLabels: {
          enabled: true
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#a22b90",
            shadeTo: "light",
            shadeIntensity: 0.5
          }
        }
      },
      series: []
    };
  },
  mounted() {
    this.series = [
      {
        data: [this.recebidas, this.visualizadas, this.compraram]
      }
    ];
  }
};
</script>
